import { render, staticRenderFns } from "./tumorDetail.vue?vue&type=template&id=5e2367b2&scoped=true"
import script from "./tumorDetail.vue?vue&type=script&lang=js"
export * from "./tumorDetail.vue?vue&type=script&lang=js"
import style0 from "./tumorDetail.vue?vue&type=style&index=0&id=5e2367b2&prod&scoped=true&lang=css"
import style1 from "./tumorDetail.vue?vue&type=style&index=1&id=5e2367b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2367b2",
  null
  
)

export default component.exports